import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';

export const checkoutCartQuery = createApi({
  reducerPath: 'checkoutCartQuery',
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  tagTypes: ['CheckoutCart', 'CheckoutCartCount'],
  endpoints: (build) => ({
    getCheckoutCartItems: build.query({
      query: ({ cartItemId, countAndTotalOnly, isStore, limit, offset }) => {
        let url = 'api/cp/cart-item';
        if (cartItemId) {
          url += `/${cartItemId}`;
        }
        return {
          url,
          method: 'get',
          params: {
            countAndTotalOnly,
            isStore,
            limit,
            offset,
          },
        };
      },
      providesTags: (_result, _error, countAndTotalOnly) =>
        countAndTotalOnly ? ['CheckoutCartCount'] : ['CheckoutCart'],
    }),
    getCheckoutCartItemDetails: build.query({
      query: (cartType = '') => ({
        url: 'api/cp/cart-item',
        method: 'get',
        params: {
          ...(cartType === 'store' && { isStore: true }),
        },
      }),
      providesTags: ['CheckoutCart'],
    }),
  }),
});

export const { useGetCheckoutCartItemsQuery, useGetCheckoutCartItemDetailsQuery } =
  checkoutCartQuery;
